<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import { prettifyHtml } from "~/util/html";
  export let request_store_key;
  const { event } = getStoresContext(request_store_key);
  const { title, additionalHeading, introduction } = $event;
  $: content = prettifyHtml($event.content);
</script>
<article class="row justify-content-center">
  <div class="col col-md-8">
    <h1 class="title-article">{@html title}</h1>
    <div>{@html additionalHeading}</div>
    <div>{@html introduction}</div>
    <div class="content">{@html content}</div>
  </div>
</article>
<style lang="scss">
  article {
    font-size: 20px;

    h1 {
      margin: 64px 0 16px;
      font-size: 32px;
      line-height: 130%;
    }

    .content {
      inline-size: 100%;
      overflow-wrap: break-word;
      word-break: break-word;
      hyphens: manual;
      margin-bottom: 4rem;
    }

    :global(img) {
      max-width: 100%;
      height: auto;
      margin: 32px 0;
    }
  }

  @media screen and (min-width: 768px) {
    article {
      font-size: 22px;
      line-height: 150%;

      h1 {
        margin: 120px 0 16px;
        font-size: 48px;
        line-height: 110%;
      }
    }
  }
</style>
